/* eslint-disable react/no-unused-state */
import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';

const AuthContext = React.createContext();

// TODO: Remove this one withAuth is removed
export const AuthConsumer = AuthContext.Consumer;

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState();
  const [user, setUser] = useState();

  const setToken = (token) => {
    if (!token) return false;
    const { roles } = jwtDecode(token);
    const isAdmin = roles.includes('admin');
    if (!isAdmin) return false;
    localStorage.setItem(process.env.AUTH_TOKEN, token);
    setIsAuth(token);
    return true;
  };

  const getToken = () => {
    if (isAuth) return isAuth;

    const token = localStorage.getItem(process.env.AUTH_TOKEN);

    if (token) {
      setIsAuth(token);
      const currentUser = jwtDecode(token);
      setUser(currentUser);
      return token;
    }

    return undefined;
  };

  useEffect(() => {
    getToken();
  }, []);

  const removeToken = () => {
    localStorage.removeItem(process.env.AUTH_TOKEN);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserRoles');
    setIsAuth();
    setUser();
  };

  const setUserGmailToLocalStorage = (authUser) => {
    localStorage.setItem(process.env.AUTH_TOKEN, authUser);
    setUser(authUser);
  };

  const setUserToLocalStorage = (token) => {
    const { email, name, userId } = jwtDecode(token);

    const authUser = {
      name,
      email,
      userId,
    };

    localStorage.setItem(process.env.AUTH_TOKEN, token);
    setUser(authUser);
  };


  const value = {
    isAuth,
    setToken,
    getToken,
    removeToken,
    setUserGmailToLocalStorage,
    setUserToLocalStorage,
    user,
  };

  return (
    <AuthContext.Provider value={value}>
      { children }
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.shape().isRequired,
};

export default AuthProvider;
